import { BarChartOutlined, CopyOutlined, ProjectOutlined, UserOutlined } from '@ant-design/icons';
import React from 'react';
import { generatePath } from 'react-router-dom';
import { Dashboard } from "../../routes/dashboard";
import { ProductionDetails, ProductionList } from '../../routes/production';
import { QuotationDetails, QuotationList } from '../../routes/quotation';
import CombiQuotationDetails from '../../routes/quotation/combi-quotation-details';
import { Users } from "../../routes/users";
import { UserRoleTypes } from './userRoles';
// import { ComplainDeatils, ComplainList } from '../../routes/complaints';

export const routesList = [

  {
    label: 'Dashboard',
    title: 'Dashboard',
    url: '/dashboard',
    component: Dashboard,
    icon: <BarChartOutlined />,
    id: 'Dashboard',
    showOnMenu: true,
    roles_allowed: [UserRoleTypes.SuperAdmin, UserRoleTypes.Admin, UserRoleTypes.Supervisor],
  },


  {
    label: 'Quotation',
    title: 'Quoatation',
    url: '/quotation',
    icon: <CopyOutlined />,
    showOnMenu: true,
    id: 'Quotation',
    roles_allowed: [UserRoleTypes.DataEntry, UserRoleTypes.SuperAdmin, UserRoleTypes.Admin, UserRoleTypes.Supervisor],

    children: [
      {
        label: 'Quotation',
        title: 'Quoatation',
        component: QuotationList,
        id: 'QuotationList',
      },
      {
        label: 'Combi Quotation Details',
        title: 'Combi Quoatation Details',
        url: '/quotation/:id/combi',
        id: 'CombiQuotationDetails',
        icon: <CopyOutlined />,
        component: CombiQuotationDetails,
        showOnMenu: false,
        roles_allowed: [UserRoleTypes.DataEntry, UserRoleTypes.SuperAdmin, UserRoleTypes.Admin, UserRoleTypes.Supervisor],
      },
      {
        label: 'Quotation Details',
        title: 'Quoatation Details',
        url: '/quotation/:id',
        id: 'QuotationDetails',
        icon: <CopyOutlined />,
        component: QuotationDetails,
        showOnMenu: false,
        roles_allowed: [UserRoleTypes.DataEntry, UserRoleTypes.SuperAdmin, UserRoleTypes.Admin, UserRoleTypes.Supervisor],
      }
    ]
  },
  {
    label: 'Production',
    title: 'Production',
    url: '/production',
    icon: <ProjectOutlined />,
    id: 'Production',
    showOnMenu: true,
    roles_allowed: [UserRoleTypes.DataEntry, UserRoleTypes.SuperAdmin, UserRoleTypes.Admin, UserRoleTypes.Supervisor],
    children: [
      {
        label: 'Production',
        title: 'Production',
        component: ProductionList,
        id: 'ProductionList',
      },
      {
        label: 'Production',
        title: 'Production',
        url: '/production/:id',
        icon: <ProjectOutlined />,
        component: ProductionDetails,
        id: 'ProductionDetails',
        showOnMenu: false,
        roles_allowed: [UserRoleTypes.DataEntry, UserRoleTypes.SuperAdmin, UserRoleTypes.Admin, UserRoleTypes.Supervisor],
      }
    ]
  },


  // {
  //   label: 'Complaints',
  //   title: 'Complaints',
  //   url: '/complains-list',
  //   icon: <UserOutlined />,
  //   component: ComplainList,
  //   showOnMenu: true,
  //   roles_allowed: [UserRoleTypes.SuperAdmin, UserRoleTypes.Admin],
  // },
  // {
  //   label: 'Complain Details',
  //   title: 'Complain Details',
  //   url: '/complain-details/:id',
  //   icon: <UserOutlined />,
  //   component: ComplainDeatils,
  //   showOnMenu: false,
  //   roles_allowed: [UserRoleTypes.SuperAdmin, UserRoleTypes.Admin],
  // },
  {
    label: 'Users',
    title: 'Users',
    url: '/users',
    icon: <UserOutlined />,
    component: Users,
    id: 'Users',
    showOnMenu: true,
    roles_allowed: [UserRoleTypes.SuperAdmin, UserRoleTypes.Admin],
  },
  // {
  //   label: 'Settings',
  //   title: 'Settings',
  //   url: '/settings',
  //   icon: <SettingOutlined />,
  //   component: Settings,
  //   showOnMenu: true,
  //   roles_allowed: [UserRoleTypes.SuperAdmin],
  // },

];

const flattenRoutes = (route, parent = []) => (
  route.children ?
    [{ url: route?.url ?? parent, component: route?.component, id: route?.id }, ...route.children.map(_r => flattenRoutes(_r, [...parent, route?.url]))] :
    { url: route?.url ?? parent, component: route?.component, id: route?.id }
)

export const generateRouteUrl = (routeId, params = {}) => {
  const matchedRoute = routesList.map(route => flattenRoutes(route))
    .flat(Infinity)
    .filter(route => route?.id)
    .find(route => route?.id === routeId)

  if (!matchedRoute)
    throw new Error(`Unable to generate URL: Invalid Route Id: ${routeId}`)

  let url = ''
  if (Array.isArray(matchedRoute.url)) {
    for (const i of matchedRoute.url.reverse()) {
      url += i
      if (i.startsWith('/')) break
    }
  }
  else {
    url = matchedRoute.url
  }

  return generatePath(url, params)
}